(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var container = document.querySelector('[data-product-recommendations]');
    if (!container) return;
    var grid = container.querySelector('[data-recommendations-grid]');

    // SSR fallback already has products — no need to fetch
    if (grid.children.length > 0) return;

    var productId = container.dataset.productId;
    var limit = container.dataset.limit || 8;
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related';

    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data.products || !data.products.length) {
          container.style.display = 'none';
          return;
        }
        var html = '';
        data.products.forEach(function (p) {
          var imgTag = '';
          var altEsc = (p.title || '').replace(/"/g, '&quot;');
          if (p.featured_image) {
            imgTag =
              '<img src="' +
              p.featured_image +
              '" alt="' +
              altEsc +
              '" loading="lazy" class="product-card__img product-card__img--primary">';
            if (p.images && p.images[1]) {
              imgTag +=
                '<img src="' +
                p.images[1] +
                '" alt="' +
                altEsc +
                '" loading="lazy" class="product-card__img product-card__img--secondary">';
            }
          } else {
            imgTag = '<div class="product-card__placeholder-box"></div>';
          }
          var priceHtml = '';
          if (p.available) {
            var price = typeof _cartFmt === 'function' ? _cartFmt(p.price) : '';
            if (p.compare_at_price && p.compare_at_price > p.price) {
              var comparePrice = typeof _cartFmt === 'function' ? _cartFmt(p.compare_at_price) : '';
              priceHtml =
                '<span class="product-card__price"><s class="product-card__price-compare">' +
                comparePrice +
                '</s>' +
                price +
                '</span>';
            } else {
              priceHtml = '<span class="product-card__price">' + price + '</span>';
            }
          } else {
            priceHtml =
              '<span class="product-card__price product-card__price--sold-out">' +
              (typeof __soldOutText !== 'undefined' ? __soldOutText : 'Out of stock') +
              '</span>';
          }
          html +=
            '<a class="product-card" href="' +
            p.url +
            '">' +
            '<div class="product-card__media">' +
            imgTag +
            '</div>' +
            '<div class="product-card__info">' +
            '<span class="product-card__title">' +
            (p.title || '').replace(/</g, '&lt;') +
            '</span>' +
            priceHtml +
            '</div></a>';
        });
        grid.innerHTML = html;
        container.style.display = '';
      })
      .catch(function () {
        /* keep SSR fallback */
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    var images = typeof __productImages !== 'undefined' ? __productImages : [];
    var imageWraps = section.querySelectorAll('[data-image-idx]');
    var thumbs = section.querySelectorAll('[data-thumb-idx]');
    var activeThumbIdx = 0;

    var imagesContainer = section.querySelector('[data-images]');

    /* ── Gallery carousel: horizontal scroll + thumb sync ── */
    function setupCarousel() {
      if (!imagesContainer || thumbs.length <= 1 || imageWraps.length <= 1) return;

      var prevBtn = section.querySelector('[data-carousel-prev]');
      var nextBtn = section.querySelector('[data-carousel-next]');

      function currentIndex() {
        var wrapWidth = imageWraps[0] ? imageWraps[0].offsetWidth : imagesContainer.clientWidth;
        var idx = Math.round(imagesContainer.scrollLeft / wrapWidth);
        return Math.max(0, Math.min(idx, imageWraps.length - 1));
      }
      function scrollToIndex(idx) {
        idx = Math.max(0, Math.min(idx, imageWraps.length - 1));
        var wrap = imageWraps[idx];
        if (wrap) imagesContainer.scrollTo({ left: wrap.offsetLeft, behavior: 'smooth' });
      }
      function updateNavState(idx) {
        if (prevBtn) prevBtn.disabled = idx <= 0;
        if (nextBtn) nextBtn.disabled = idx >= imageWraps.length - 1;
      }

      function updateThumbFromScroll() {
        var idx = currentIndex();
        updateNavState(idx);
        if (idx !== activeThumbIdx) {
          thumbs[activeThumbIdx] && thumbs[activeThumbIdx].classList.remove('is-active');
          activeThumbIdx = idx;
          thumbs[activeThumbIdx] && thumbs[activeThumbIdx].classList.add('is-active');
          thumbs[activeThumbIdx] &&
            thumbs[activeThumbIdx].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      }
      imagesContainer.addEventListener('scroll', updateThumbFromScroll, { passive: true });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          scrollToIndex(parseInt(thumb.dataset.thumbIdx, 10));
        });
      });
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollToIndex(currentIndex() - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollToIndex(currentIndex() + 1);
        });
      }
      updateNavState(currentIndex());
    }

    setupCarousel();

    /* ── Fullscreen lightbox ── */
    var lightbox = document.getElementById('product-lightbox');
    var lbImagesEl = lightbox ? lightbox.querySelector('.product-lightbox__images') : null;
    var lbThumbs = lightbox ? lightbox.querySelectorAll('[data-lightbox-thumb-idx]') : [];
    var lbImages = lightbox ? lightbox.querySelectorAll('[data-lb-image-idx]') : [];
    var lbActiveIdx = 0;
    var lbLenis = null;
    var lbLenisRaf = null;
    var lbMobile = window.matchMedia('(max-width: 900px)');

    if (lightbox) {
      lightbox.addEventListener(
        'wheel',
        function (e) {
          e.stopPropagation();
        },
        { passive: true }
      );
      lightbox.addEventListener(
        'touchmove',
        function (e) {
          e.stopPropagation();
        },
        { passive: true }
      );
      lightbox.addEventListener('scroll', onLightboxScroll, { passive: true });
      if (lbImagesEl && lbMobile.matches) {
        lbImagesEl.addEventListener('scroll', onLightboxScroll, { passive: true });
      }
    }

    function syncPageToImage(idx) {
      var pageImage = section.querySelector('[data-image-idx="' + idx + '"]');
      if (pageImage) {
        var rect = pageImage.getBoundingClientRect();
        var offset = window.scrollY + rect.top - window.innerHeight * 0.15;
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    }

    function getLightboxIndexFromScroll() {
      if (!lightbox || lbImages.length === 0) return 0;
      if (lbMobile.matches && lbImagesEl) {
        var scrollLeft = lbImagesEl.scrollLeft;
        var wrapWidth = lbImages[0] ? lbImages[0].offsetWidth : lbImagesEl.clientWidth;
        var idx = Math.round(scrollLeft / wrapWidth);
        return Math.max(0, Math.min(idx, lbImages.length - 1));
      }
      var scrollTop = lbLenis && typeof lbLenis.scroll === 'number' ? lbLenis.scroll : lightbox.scrollTop;
      var center = scrollTop + lightbox.clientHeight / 2;
      for (var i = 0; i < lbImages.length; i++) {
        var top = lbImages[i].offsetTop;
        var bottom = top + lbImages[i].offsetHeight;
        if (center >= top && center < bottom) return i;
        if (center < top) return Math.max(0, i - 1);
      }
      return lbImages.length - 1;
    }

    var lbScrollRaf = null;
    function onLightboxScroll() {
      if (!lbIsOpen) return;
      if (lbScrollRaf) return;
      lbScrollRaf = requestAnimationFrame(function () {
        lbScrollRaf = null;
        var idx = getLightboxIndexFromScroll();
        if (idx !== lbActiveIdx) {
          lbActiveIdx = idx;
          if (lbThumbs[idx]) {
            lbThumbs.forEach(function (t, i) {
              t.classList.toggle('is-active', i === idx);
            });
            lbThumbs[idx].scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }
        }
        if (lbIsOpen && !lbJustOpened) syncPageToImage(idx);
      });
    }

    var lbObserver = null;
    if (lightbox && lbImages.length > 1 && lbThumbs.length > 1) {
      var lbRatios = {};
      lbObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            lbRatios[entry.target.dataset.lbImageIdx] = entry.intersectionRatio;
          });
          var best = -1,
            bestRatio = 0;
          Object.keys(lbRatios).forEach(function (k) {
            if (lbRatios[k] > bestRatio) {
              bestRatio = lbRatios[k];
              best = parseInt(k, 10);
            }
          });
          if (best >= 0 && best !== lbActiveIdx) {
            lbThumbs[lbActiveIdx] && lbThumbs[lbActiveIdx].classList.remove('is-active');
            lbActiveIdx = best;
            lbThumbs[lbActiveIdx] && lbThumbs[lbActiveIdx].classList.add('is-active');
            lbThumbs[lbActiveIdx] &&
              lbThumbs[lbActiveIdx].scrollIntoView({
                block: 'nearest',
                behavior: 'smooth',
              });
            if (lbIsOpen && !lbJustOpened) syncPageToImage(best);
          }
        },
        {
          root: lightbox,
          threshold: [0, 0.25, 0.5, 0.75, 1],
        }
      );
    } else if (lightbox && lbImages.length > 0) {
      lbObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio > 0.5) {
              var idx = parseInt(entry.target.dataset.lbImageIdx, 10);
              if (idx !== lbActiveIdx) {
                lbActiveIdx = idx;
                if (lbIsOpen && !lbJustOpened) syncPageToImage(idx);
              }
            }
          });
        },
        {
          root: lightbox,
          threshold: [0.5],
        }
      );
    }

    var lbIsOpen = false;
    var lbJustOpened = false;
    var lbScrollY = 0;
    var lbScrollbarWidth = 0;

    function openLightbox(idx) {
      if (!lightbox || !images.length || lbIsOpen) return;
      lbIsOpen = true;
      lbJustOpened = true;
      setTimeout(function () {
        lbJustOpened = false;
      }, 400);

      if (lightbox.parentNode !== document.body) {
        document.body.appendChild(lightbox);
      }

      lbScrollY = window.scrollY || document.documentElement.scrollTop;
      lbScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      document.documentElement.style.overflow = 'hidden';
      if (lbScrollbarWidth > 0) {
        document.body.style.paddingRight = lbScrollbarWidth + 'px';
      }

      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');

      var target = lightbox.querySelector('[data-lb-image-idx="' + idx + '"]');

      if (lbMobile.matches && lbImagesEl) {
        lbImagesEl.scrollLeft = target ? target.offsetLeft : 0;
      } else {
        var scrollTop = target ? target.offsetTop : 0;
        if (typeof window.Lenis !== 'undefined' && lbImagesEl) {
          lbLenis = new window.Lenis({
            wrapper: lightbox,
            content: lbImagesEl,
            duration: 1.05,
            easing: function (t) {
              return Math.min(1, 1.001 - Math.pow(2, -10 * t));
            },
          });
          lbLenis.scrollTo(scrollTop, { immediate: true });
          if (typeof lbLenis.on === 'function') {
            lbLenis.on('scroll', function () {
              if (lbIsOpen) onLightboxScroll();
            });
          }
          function lbLenisRafLoop(time) {
            if (lbLenis) {
              lbLenis.raf(time);
              lbLenisRaf = requestAnimationFrame(lbLenisRafLoop);
            }
          }
          lbLenisRaf = requestAnimationFrame(lbLenisRafLoop);
        } else if (target) {
          lightbox.scrollTop = scrollTop;
        }
        if (lbObserver) {
          lbImages.forEach(function (w) {
            lbObserver.observe(w);
          });
        }
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          lightbox.classList.add('is-open');
        });
      });
    }

    function closeLightbox() {
      if (!lightbox || !lbIsOpen) return;
      lbIsOpen = false;
      lightbox.classList.remove('is-open');

      setTimeout(function () {
        if (lbLenis) {
          lbLenis.destroy();
          lbLenis = null;
        }
        if (lbLenisRaf) {
          cancelAnimationFrame(lbLenisRaf);
          lbLenisRaf = null;
        }
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        if (lbObserver) {
          lbImages.forEach(function (w) {
            lbObserver.unobserve(w);
          });
        }
        lightbox.scrollTop = 0;
        if (lbImagesEl) lbImagesEl.scrollLeft = 0;
        lbThumbs.forEach(function (t, i) {
          t.classList.toggle('is-active', i === 0);
        });
        lbActiveIdx = 0;

        document.documentElement.style.overflow = '';
      }, 350);
    }

    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.product__zoom-trigger');
      if (!btn) return;
      openLightbox(parseInt(btn.dataset.slideIndex, 10) || 0);
    });

    if (lightbox) {
      if (lbImagesEl) {
        lbImagesEl.addEventListener('click', closeLightbox);
        lbImagesEl.setAttribute('aria-label', typeof __closeText !== 'undefined' ? __closeText : 'Close');
      }
      var lbCloseBtn = lightbox.querySelector('.product-lightbox__close-btn');
      if (lbCloseBtn) {
        lbCloseBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          closeLightbox();
        });
      }

      lbThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (e) {
          e.stopPropagation();
          var idx = parseInt(thumb.dataset.lightboxThumbIdx, 10);
          var target = lightbox.querySelector('[data-lb-image-idx="' + idx + '"]');
          if (!target) return;
          if (lbMobile.matches && lbImagesEl) {
            lbImagesEl.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
          } else if (lbLenis) {
            lbLenis.scrollTo(target.offsetTop, { immediate: true });
          } else {
            target.scrollIntoView({ block: 'start' });
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (!lbIsOpen) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          closeLightbox();
        }
      });
    }

    /* ── Variant selector ── */
    var variants = typeof __productVariants !== 'undefined' ? __productVariants : [];
    var addBtn = document.querySelector('[data-add-btn]');
    var priceEl = document.querySelector('[data-product-price]');
    var currentPriceEl = document.querySelector('[data-current-price]');
    var comparePriceEl = document.querySelector('[data-compare-price]');
    var saleBadge = document.querySelector('[data-sale-badge]');
    var formInput = document.querySelector('#product-form input[name="id"]');

    function updateVariant(variantId) {
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === variantId) {
          variant = variants[i];
          break;
        }
      }
      if (!variant) return;

      if (formInput) formInput.value = variant.id;

      document.querySelectorAll('.product__variant-btn').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.variantId, 10) === variant.id);
      });

      if (currentPriceEl && typeof _cartFmt === 'function') {
        currentPriceEl.textContent = _cartFmt(variant.price);
      }

      var isSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (comparePriceEl) {
        if (isSale) {
          comparePriceEl.innerHTML = '<s>' + _cartFmt(variant.compare_at_price) + '</s>';
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.classList.add('hidden');
        }
      }
      if (saleBadge) saleBadge.classList.toggle('hidden', !isSale);
      if (addBtn) addBtn.disabled = !variant.available;

      if (priceEl) priceEl.classList.toggle('hidden', !variant.available);

      var soldOutEl = document.querySelector('[data-sold-out]');
      if (soldOutEl) {
        soldOutEl.classList.toggle('hidden', variant.available);
      }

      if (variant.featured_image) {
        for (var j = 0; j < images.length; j++) {
          if (images[j].id === variant.featured_image.id) {
            var target = section.querySelector('[data-image-idx="' + j + '"]');
            if (target && imagesContainer) {
              imagesContainer.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
            }
            break;
          }
        }
      }

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + '?variant=' + variant.id);
      }
    }

    document.querySelectorAll('.product__variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateVariant(parseInt(btn.dataset.variantId, 10));
      });
    });

    /* ── Add to cart ── */
    var form = document.getElementById('product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.classList.add('is-loading');
        }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function () {
            if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
            else if (typeof openCartDrawer === 'function') openCartDrawer();
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (addBtn) {
              addBtn.disabled = false;
              addBtn.classList.remove('is-loading');
            }
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
